import { UnitTypeSelect } from "@/components/form/unit-type-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

type UnitTypeFieldExtraProps = {
  /**
   * Gap in px between the trigger and the popover, as Radix measures it.
   * Omitted leaves the control's own default (4) in place, so a caller that
   * does not care about placement never has to state one.
   */
  sideOffset?: number;
};

/** **Value is a unit-type key** (`string`). */
export type UnitTypeFieldProps = PickerFieldProps<
  string,
  UnitTypeFieldExtraProps
>;

export const UnitTypeField = makePickerField<string, UnitTypeFieldExtraProps>({
  name: "UnitTypeField",
  control: UnitTypeSelect,
  popout: true,
  controlProps: (props) => ({
    sideOffset: props.sideOffset,
  }),
});
